import { render, staticRenderFns } from "./socialCard.vue?vue&type=template&id=32d18be5&scoped=true&"
import script from "./socialCard.vue?vue&type=script&lang=js&"
export * from "./socialCard.vue?vue&type=script&lang=js&"
import style0 from "./socialCard.vue?vue&type=style&index=0&id=32d18be5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d18be5",
  null
  
)

export default component.exports